import React, { Component } from 'react';
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import Button from '../../../../../components/UI/Button';
import TextBox from "../../../../../components/TextBox";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "config/constants";
import { decimalFilter } from '../../../../../common/Utils';
import Select from "react-select";

const EDIT_TRAINER = "EDIT TRAINER DETAILS";
const TRAINER_NAME = "Name";
const DONE_TEXT = "SAVE";
const CLOSE_TEXT = "CLOSE";
const RATE = "Rate $/min";
const GYMS = "Gyms";
const TAG = "Affiliation / Brand";

export default class EditTrainer extends Component {

    constructor (props) {
        super(props);
        var gyms = JSON.parse(JSON.stringify(this.props.trainer.gyms));
        // All affiliations / brands / tags
        var affiliations = this.props.tags;
        gyms = gyms.map(gym => ({ value: gym.id, label: gym.gym_name }))
        var selectedTag = this.props.trainer.affiliated_to && this.props.trainer.affiliated_to.name ? this.props.trainer.affiliated_to.name : null;
        this.state = {
            rate: this.props.trainer.rate,
            name: this.props.trainer.name,
            gyms: gyms,
            tagObj: affiliations.find(affiliation => selectedTag == affiliation.label) //Selected affiliation object
        }
    }

    render () {
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={EDIT_TRAINER}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{TRAINER_NAME}</p>
                    <TextBox
                        style={{
                            width: "222px"
                        }}
                        placeholder={"Name"}
                        defaultValue={this.props.name}
                        value={this.state.name}
                        onChange={(event)=>{
                            this.setState({
                                name: event.target.value
                            })
                        }}
                    />
                </div>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{RATE}</p>
                    <TextBox
                        style={{
                            width: "222px"
                        }}
                        placeholder={"Rate"}
                        defaultValue={this.props.rate}
                        value={this.state.rate}
                        onChange={(event)=>{
                            if (!isNaN(event.target.value) && decimalFilter(event.target.value, 2)) {
                                this.setState({
                                    rate: event.target.value
                                })
                            }
                        }}
                    />
                </div>
                {
                    <div style={style.selectorWrapper}>
                        <p style={style.selectorLabel}>{TAG}</p>
                        <Select
                            styles={{
                                container: (base) => ({
                                    ...base,
                                    display: 'flex',
                                    width: '250px',
                                }),
                                control: (base, state) => {
                                    return {
                                        ...base,
                                        boxShadow: state.isFocused ? "0 0 3px 2px rgba(0,180,210,0.38)" : 0,
                                        "&:hover": {
                                            borderColor: state.isFocused ? 'rgba(0,180,210,1)' : 'black'
                                        },
                                        border: state.isFocused ? "1px solid rgba(0,180,210,1)" : "1px solid black",
                                        borderRadius: "6px",
                                        padding: "2px",
                                        display: 'flex',
                                        marginRight: "10px",
                                        height: '48px',
                                        width: '250px',
                                    };
                                },
                                multiValueLabel: (base) => {
                                    return {
                                        ...base,
                                        backgroundColor: 'rgba(255,255,255,0.8)'
                                    }
                                },
                                valueContainer: (base) => {
                                    return {
                                        ...base,
                                        display: 'flex',
                                        flexGrow: 1,
                                        flexWrap: "nowrap",
                                    }
                                },
                                option: (base) => {
                                    return {
                                        ...base,
                                        textAlign: 'start'
                                    }
                                }
                            }}
                            placeholder={TAG}
                            options={this.props.tags}
                            value={this.state.tagObj}
                            isMulti={false}
                            onChange={(tag) => {
                                this.setState({
                                    tagObj: tag
                                })
                            }} />
                    </div>
                }
                {
                    this.state.editGyms &&
                    <div style={style.selectorWrapper}>
                        <p style={style.selectorLabel}>{GYMS}</p>
                        <Select
                        styles={{
                            container: (base) => ({
                            ...base,
                            display: 'flex',
                            width: '250px',
                            }),
                            control: (base, state) => {
                            return {
                                ...base,
                                boxShadow: state.isFocused ? "0 0 3px 2px rgba(0,180,210,0.38)" : 0,
                                "&:hover": {
                                    borderColor: state.isFocused ? 'rgba(0,180,210,1)' : 'black'
                                },
                                border: state.isFocused ? "1px solid rgba(0,180,210,1)" : "1px solid black",
                                borderRadius: "6px",
                                padding: "2px",
                                display: 'flex',
                                marginRight: "10px",
                                height: '48px',
                                width: '250px',
                                overflowX: 'auto',
                                scrollbarWidth: '1px'
                            };
                            },
                            multiValueLabel : (base) => {
                                return {
                                    ...base,
                                    backgroundColor: 'rgba(255,255,255,0.8)'
                                }
                            },
                            valueContainer:  (base) => {
                                return {
                                    ...base,
                                    display: 'flex',
                                    flexGrow: 1,
                                    flexWrap: "nowrap",
                                }
                            },
                            option : (base) => {
                                return {
                                    ...base,
                                    textAlign: 'start'
                                }
                            }
                        }}
                        placeholder="Gyms"
                        options={this.props.gyms}
                        value={this.state.gyms}
                        isMulti={true}
                        onChange={(gyms) => {
                            this.setState({
                                gyms : gyms
                            })
                        }}/>
                    </div>
                }
                <div style={style.doneButtonWrapper}>
                    <Button
                        style={style.doneButton}
                        type="primary"
                        onClick={this.save}>
                        {DONE_TEXT}
                    </Button>
                    <Button
                        style={style.closeButton}
                        type="primary"
                        onClick={this.props.close}>
                        {CLOSE_TEXT}
                    </Button>
                </div>
            </ModalOverlay>
        )
    }

    save = () => {
        if(!this.state.name) {
            toast("Please provide trainer name")
        } else if (!this.state.rate) {
            toast("Please provide rate")
        } else {
            var toastId = toast("Updating details...")
            var gyms = this.state.gyms.map(gym => gym.value)
            var selectedTagId = this.state.tagObj && this.state.tagObj.value ? this.state.tagObj.value : null;
            var trainer = {
                name: this.state.name,
                rate: this.state.rate,
                gyms: gyms,
                affiliated_to: selectedTagId
            }
            axios.put(`${API_URL}/trainer/profile?trainerId=${this.props.trainer.id}`,
            trainer,
            {
                headers: {
                    "x-access-token": localStorage.getItem("access_token")
                }
            }).then((res)=>{
                var trainer = this.props.trainer
                trainer.name = this.state.name
                trainer.rate = parseFloat(this.state.rate)
                trainer.affiliated_to = res.data.affiliated_to;
                trainer.updatedAt = res.data.updatedAt;
                toast.dismiss(toastId);
                toastId = toast("Updated successfully");
                setTimeout(() => {
                    this.props.close();
                    toast.dismiss(toastId);
                }, 1000)
            }).catch((e)=>{
                toast.dismiss(toastId);
                toastId = toast("Updated failed " + e.message);
                setTimeout(() => {
                    toast.dismiss(toastId);
                }, 2000)
            })
        }
    }
}

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    doneButtonWrapper: {
        width: "400",
        display: "flex",
        justifyContent: "space-around",
        marginTop: 20
    },
    doneButton: {
        width: "160px",
        fontSize: "20px"
    },
    closeButton: {
        width: "160px",
        fontSize: "20px",
        marginLeft:"20px"
    },
    selectorWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "nowrap",
        height: 70
    },
    selectorLabel: {
        fontSize: "22px",
        color: "#444445",
        marginRight: "15px",
        width: "150px",
        textAlign: "left",
        height: 20
    },
    input: {
        border: "1px solid #444445",
        borderRadius: 50,
        fontSize: 18,
        color: theme.color.primaryBlue,
        padding: 10,
        paddingLeft: 20,
        minWidth: 250,
        textAlign: "left",
        backgroundColor: theme.color.textLightWhite
    },
}